// import React, { useEffect } from 'react'
import styled from 'styled-components'
import DeskTopRegistration from 'components/desktop/page/Registration'

const Registration = styled(DeskTopRegistration)`
  padding: 0 20px;
  > h1 {
    display: none;
  }
  > h2 {
    margin-top: 28px;
  }
  .terms_view {
    height: 320px;
    margin: 8px 0;
  }
  > .button_wrapper {
    box-sizing: border-box;
    flex-direction: column-reverse;
    height: 152px;
  }
`
export default Registration
